module.exports = __webpack_public_path__ + "images/emoji/congratulations.76569e5f09d668090cfb.png";